import React from "react";

const OtherButton = ({ children }) => {
  return <div className="other-buttons">{children}</div>;
};

export default OtherButton;
